// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2334":"ddbe2d45","2804":"6c1552bc","3303":"d7bf8155","6379":"aed3f3b4","6642":"b2d0f933","7608":"e7a1d701","8181":"45f754b1"}[chunkId] + ".chunk.css";
};